import { render, staticRenderFns } from "./tagFields.vue?vue&type=template&id=2608b337&scoped=true"
import script from "./tagFields.vue?vue&type=script&lang=js"
export * from "./tagFields.vue?vue&type=script&lang=js"
import style0 from "./tagFields.vue?vue&type=style&index=0&id=2608b337&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2608b337",
  null
  
)

export default component.exports